<template>
  <div class="wlx-user-upload-avatar-wrapper">
    <el-upload
      ref="upload"
      :accept="acceptExts[format]"
      list-type="picture-card"
      :file-list="fileList"
      :show-file-list="true"
      :auto-upload="true"
      :data="access"
      :action="action"
      :multiple="multiple"
      :limit="limit"
      :before-upload="beforeUpload"
      :on-remove="onRemoveHandler"
      :on-progress="onProgress"
      :on-success="onSuccessHandler"
      :on-error="onError"
      :class="{'hide-uploader': hideUploader}"
      :on-exceed="onExceed"
      v-loading="loading"
    >
      <i class="el-icon-plus"></i>
      <div slot="tip" class="el-upload__tip upload-img-tip-con" v-if="isShowTip">小二寸彩底照片，35mm*45mm，图片不小于200k</div>
    </el-upload>
  </div>
</template>

<script>
import Vue from "vue";
import Newuploader from "lib/mixins/Newuploader";

export default {
  name: "avatarUpload",
  mixins: [Newuploader],
  props: {
    format: {
      type: String,
      default: "image"
    },
    tip: {
      type: String
    },
    count: {
      type: Number,
      default: 1
    },
    minHeight: {
      type: Number,
      default: 0
    },
    minWidth: {
      type: Number,
      default: 0
    },
    isShowTip:{
      type:Boolean,
      default:false
    },
    minSize:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      limit: 1,
      isNeedSave: 1, // 1 保存为封面、头像等不在课件中展示
      acceptExts: {
        image: ".jpg,.jpeg"
        // file: ".jpg,.jpeg,.png,.gif,.zip,.pdf"
      },
      acceptTypes: ["image/jpg", "image/jpeg"],
      hideUploader: false,
      multiple: false,
      docId: "",
      docUrl: "",
      loading:false
    };
  },
  watch: {
    //
  },
  created() {
    if (this.count != 1) {
      this.limit = this.count;
      this.multiple = true;
    } else {
      this.limit = 2;
    }
  },
  beforeDestroy() {
    this.fileList = [];
  },
  methods: {
    beforeUpload(file) {
      var that = this;
      // if(file.size < this.minSize){
      //   this.$message.warning({
      //       title: file.name,
      //       message: "图片应大于50k"
      //     });
      //     return false;
      // }
      if (this.format === "image") {
        let isPngJpg = this.acceptTypes.includes(file.type);
        if (!isPngJpg) {
          this.$message.info({
            title: file.name,
            message: "只能上传 JPG 格式的图片"
          });
          return false;
        }
      }

      var fileData = file;
      //读取图片数据
      return new Promise(resolve => {
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = e.target.result;
          //加载图片获取图片真实宽度和高度
          var image = new Image();
          image.src = data;
          image.onload = function() {
            var width = image.width;
            var height = image.height;
            if (image.width >= that.minWidth && image.height >= that.minHeight) {
              if (that.count === 1) {
                let f = that.$refs.upload.uploadFiles;
                if (f.length > 1) {
                  let uf = f[0];
                  console.log(uf);
                  that.$refs.upload.handleRemove(uf);
                }
              }
              that.addFile(file).then(resolve);
              that.loading = true;
            } else {
              that.$message.warning(
                "上传图片必须大于:" + that.minWidth + "*" + that.minHeight
              );
              that.$refs.upload.uploadFiles = [];
              return false;
            }
          };
          // image.src= data;
        };
        reader.readAsDataURL(fileData);
      });
    },
    onExceed(files, fileList) {
      this.$message.warning(
        `本次选择了 ${files.length} 个文件，共选择了 ${files.length +
          fileList.length} 个文件, 超出单次最大上传文件 ${this.limit} 个的限制`
      );
    },
    onRemoveHandler() {
      if (this.onRemove) {
        this.onRemove();
      }
    },
    onSuccessHandler(res, file, uploadFiles) {
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        file.url = res.docPath;
        this.$emit("update:docId", res.docId);
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss">
.wlx-user-upload-avatar-wrapper{
    margin: 0 auto;
    width:148px;
    height: 148px;
    overflow: hidden;
    .upload-img-tip-con{
      margin-top: -60px;
      padding: 0 10px;
      color:#f76a71;
    }
}
.thumbnail-uploader {
  .el-upload-list--picture-card {
    .el-upload-list__item {
      width: 200px;
      height: 120px;
    }
  }
  .thumbnail-uploader-icon {
    margin-top: 0;
    font-size: 40px;
  }
  .el-upload--picture-card {
    width: 200px;
    height: 120px;
  }
}
</style>
